import React, { useEffect, useState } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { Spin } from '@arco-design/web-react';
import { verifyToken } from '@/utils/checkLogin';

interface ProtectedRouteProps extends RouteProps {
  component: React.ComponentType<any>;
}

/**
 * 受保护的路由组件
 * 验证用户是否已登录，如果没有登录则重定向到登录页面
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component: Component,
  ...rest
}) => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const checkAuthStatus = async () => {
      // 如果正在登录流程中，不执行验证
      if (sessionStorage.getItem('login_in_progress')) {
        setLoading(false);
        setIsAuthenticated(false);
        return;
      }

      try {
        const { valid, user } = await verifyToken();
        setIsAuthenticated(valid);
        setUserData(user);
      } catch (error) {
        console.error('认证检查失败:', error);
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuthStatus();
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Spin tip="验证登录状态..." />
      </div>
    );
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} user={userData} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
              search: `?redirect=${encodeURIComponent(
                props.location.pathname
              )}${
                props.location.search
                  ? encodeURIComponent(props.location.search)
                  : ''
              }`,
            }}
          />
        )
      }
    />
  );
};

export default ProtectedRoute;
